export const DETECTED_ISSUE_CATEGORY_SYSTEM =
  'http://lifeomic.com/fhir/fountain-life-detected-issue-category';

export const DETECTED_ISSUE_REVIEW_STATUS_SYSTEM =
  'http://lifeomic.com/fhir/fountain-life-detected-issue-review-status';

export const DETECTED_ISSUE_EXPLANATION_MARKDOWN_URL =
  'http://lifeomic.com/fhir/fountain-life-detected-issue-explanation-markdown';

export const DETECTED_ISSUE_CITATION_URL =
  'http://lifeomic.com/fhir/fountain-life-detected-issue-citation';

export const REVIEW_STATUS_ACCEPTED = 'accepted';
export const REVIEW_STATUS_RESOLVED = 'resolved';
export const REVIEW_STATUS_NEEDS_REVIEW = 'needs-review';

export const ACTIVE_REVIEW_STATUSES = new Set([
  REVIEW_STATUS_ACCEPTED,
  REVIEW_STATUS_RESOLVED,
]);
